export default [{
  path: '/grupos-arquivos',
  component: () => import('@/views/Index'),
  children: [
    {
      name: 'Grupos de Arquivos',
      path: '',
      component: () => import('@/views/gruposArquivos/Index.vue'),
      meta: {
        requiresAuth: true,
        admin: true,
        breadcrumb: [
          { name: 'Dados', path: '/dados' },
          { name: 'Grupos de Arquivos' }
        ]
      }
    },
    {
      name: 'Grupos de Arquivos Adicionar',
      path: 'edit',
      component: () => import('@/views/gruposArquivos/Edit.vue'),
      meta: {
        requiresAuth: true,
        admin: true,
        breadcrumb: [
          { name: 'Dados', path: '/dados' },
          { name: 'Grupos de Arquivos', path: '/grupos-arquivos' },
          { name: 'Adicionar' }
        ]
      }
    },
    {
      name: 'Grupos de Arquivos Editar',
      path: 'edit/:id',
      component: () => import('@/views/gruposArquivos/Edit.vue'),
      meta: {
        requiresAuth: true,
        admin: true,
        breadcrumb: [
          { name: 'Dados', path: '/dados' },
          { name: 'Grupos de Arquivos', path: '/grupos-arquivos' },
          { name: 'Editar' }
        ]
      }
    }
  ]
}]